<div class="modal-header">
    <h2 mat-dialog-title trans>Move items</h2>
    <button type="button" mat-icon-button (click)="close()" class="close-button" tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<form ngNativeValidate (ngSubmit)="confirm()">
    <mat-dialog-content>
        <folders-tree
            [expanded]="true"
            [movingEntries]="selectedEntries$ | async"
            [disableContextMenu]="true"
            [selectedFolder]="getRootFolder().hash"
            [showRootNode]="true"
            (folderSelected)="selectedFolder = $event"
        ></folders-tree>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="close()" type="button" mat-button class="cancel-button" trans>Cancel</button>
        <button type="submit" mat-raised-button color="primary" class="submit-button" [disabled]="!canMove() || (loading | async)" trans>Move</button>
    </mat-dialog-actions>
</form>